import $ from 'jquery'
import Vector from 'toxilibs/vector.js'
import Screen from 'toxilibs/screen.js'

const canvasWidth = 400


// zoomed out as a whole (canvas and answer placeholder) when the question is narrower than the canvas
function fitToQuestion (canvasContainer) {
    const questionWidth = $(canvasContainer).parent().width()
    $(canvasContainer).css('zoom', Math.min(1, questionWidth / canvasWidth))
}

$(window).on('resize', () => $('.geoscreen').each((index, canvasContainer) => fitToQuestion(canvasContainer)))


function GeoScreen ({height = 200, container}) {
    this.canvasContainer = $('<div class="geoscreen">')

    const canvas = $('<canvas width="' + canvasWidth + '" height="' + height + '">')
    this.canvasContainer.append(canvas)

    container.append(this.canvasContainer)

    this.screen = new Screen(canvas[0])
    this.screen.setScale(30)

    this.toDraw    = []
    this.afterDraw = []
    this.zones     = []

}


GeoScreen.prototype.addPoint = function (params) {

    params.color = params.color || '#FF0000'

    this.addPointWithoutLabel(params)

    if (params.name) {
        const labelDirection = params.labelDirection || new Vector(1, 1)
        this.addPointLabel(params, labelDirection)
    }

}



GeoScreen.prototype.addPointWithoutLabel = function ({x, y, radius = 0.1, color = '#FF0000'}) {

    const {screen} = this

    this.zones.push({x, y, margin: 0.3})

    this.toDraw.push(function () {
        screen.drawCircle({
            center: {x, y},
            radius,
            strokeColor: '#000',
            fillColor:   color
        })
    })
}



GeoScreen.prototype.addPointLabel = function (point, labelDirection) {

    labelDirection = labelDirection || new Vector(-1, 0)

    const v = new Vector({direction: labelDirection.direction, length: 15 / this.screen.scale}) //FIXME screen.scale too early
    const labelPosition = v.plus(point)

    this.addText({
        text:   point.name,
        center: labelPosition,
        color:  point.color
    })
}


GeoScreen.prototype.addText = function (params) {
    const {screen} = this
    const {center, color} = params

    this.zones.push({
        x: center.x,
        y: center.y,
        margin: 15 / screen.scale //FIXME screen.scale too early
    })


    this.toDraw.push(function () {
        screen.drawText(params)

        //FIXME
        if (params.upperSymbol) {
            screen.drawText({
                text:   params.upperSymbol,
                center: {
                    x: center.x,
                    y: center.y + 13 / screen.scale
                },
                color
            })
        }
    })
}


GeoScreen.prototype.addVector = function ({
    name,
    originX, originY, x, y,
    branchLength,
    labelUnder,
    color = '#FF0000'
}) {
    const {screen} = this

    const origin = new Vector(originX, originY)
    const vector = new Vector(x, y)

    this.zones.push(origin)
    this.zones.push(origin.plus(vector))

    //TODO arrow size bigger when length is < 2
    this.toDraw.push(function () {
        screen.drawArrow({
            origin,
            vector,
            branchLength: branchLength || 12 / (screen.scale * vector.length),
            strokeColor:  color,
            lineWidth:    2 / screen.scale
        })
    })


    if (name) {
        const angle = labelUnder ? -90 : 90

        const delta = vector.rotate(angle).setLength(20 / screen.scale) //FIXME screen.scale too early
        const labelPosition = vector.multiply(0.5).plus(origin).plus(delta)

        this.addText({
            text:   name,
            center: labelPosition,
            color,
            upperSymbol: '→'
        })

    }
}


GeoScreen.prototype.addVectorWithPoints = function ({name, start, end, color}) {
    const vector = new Vector({from: start, to: end})

    start.labelDirection = vector.multiply(-1)
    start.radius = 0.05
    this.addPoint(start)

    end.labelDirection = vector
    end.radius = 0.05
    this.addPoint(end)

    this.addVector({
        name,
        color,
        originX: start.x,
        originY: start.y,
        x:       vector.x,
        y:       vector.y
    })

}


GeoScreen.prototype.addPolygon = function ({points, color = '#FF0000'}) {

    addZonesForPoints(this, points)

    const {screen} = this


    this.toDraw.push(function () {
        screen.drawPolygon({
            points,
            strokeColor: color
        })
    })



    const count = points.length

    points.forEach((point, i) => {
        if (point.name) {
            point.color = point.color || color

            const prevPoint = points[(count + i - 1) % count]
            const nextPoint = points[(i + 1) % count]

            this.addPointLabel(point, labelDirectionFromPolygonAngle(point, prevPoint, nextPoint))
        }

        this.addPointWithoutLabel(point)
    })

}


//FIXME remove and handle automatically
GeoScreen.prototype.addVisibleZone = function (params) {
    this.zones.push(params)
}


GeoScreen.prototype.addAnswerPlaceholder = function (position) {
    const $placeholder = $('<span class="answer_placeholder">?</span>')
    this.canvasContainer.append($placeholder)

    this.afterDraw.push(() => {
        const {x, y} = this.screen.coords2pix(position)
        $placeholder.css({
            top:  Math.floor(y) - 15,
            left: Math.floor(x) - 4
        })
    })

}


GeoScreen.prototype.addImage = function (params) {
    const {screen} = this
    this.toDraw.push(function () {
        screen.drawImage(params)
    })
}


GeoScreen.prototype.drawAll = function (params = {}) {

    drawAxesAndGrid(this, params)

    setOptimalView(this, params)

    this.toDraw.forEach(f => f())
    this.afterDraw.forEach(f => f())

    fitToQuestion(this.canvasContainer)
}



GeoScreen.prototype.drawRotatedGrid = function ({orientation}) {
    const {screen} = this

    this.toDraw.push(function () {
        const center = new Vector(
            screen.center.x,
            screen.center.y
        )

        const delta = center.rotate(-orientation).minus(center)
        screen.translateCenter(delta)
        screen.setOrientation(orientation)
        screen.drawGrid({
            step:  1,
            color: '#FCC',
            opacityLimit: 1
        })
        screen.setOrientation(0)
        screen.setCenter(center)
    })


}



function setOptimalView (geoScreen, {noAxes, maxScale = 50, margin}) {
    if (!noAxes) {
        geoScreen.zones.push({x: 0, y: 0})
    }

    geoScreen.screen.setOptimalView(geoScreen.zones, {maxScale, margin})
}



function drawAxesAndGrid (geoScreen, {noGrid, noAxes}) {

    const {screen} = geoScreen


    if (!noAxes) {

        geoScreen.toDraw.unshift(function () {
            screen.drawAxes({
                color: '#226ea5'
            })
        })

        geoScreen.addPoint({
            name: 'O',
            x: 0,
            y: 0,
            color: '#226ea5'
        })
    }


    if (!noGrid) {
        geoScreen.toDraw.unshift(function () {
            screen.drawGrid({
                step:  1,
                color: '#D3D3D3',
                alphaLimit: 1
            })
        })
    }

}


function addZonesForPoints (geoScreen, points) {
    for (let point of points) {
        let {x, y} = point
        geoScreen.zones.push({x, y, margin: 0.3})
    }
}



function labelDirectionFromPolygonAngle (point, prevPoint, nextPoint) {
    const prevVector = new Vector({from: point, to: prevPoint, length: 1})
    const nextVector = new Vector({from: point, to: nextPoint, length: 1})
    return prevVector.plus(nextVector).multiply(-1)
}


export default GeoScreen

